module.exports = __webpack_public_path__ + "5f4752ca81da77b532d855b04482f4c3.png";